exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddressList_primaryText_vZ4uH {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.AddressList_addressItem_3QhGr {\n  transition: all 0.3s ease;\n  height: 72px;\n  overflow: hidden;\n  transform: translate3d(0,0,0);\n}\n\n.AddressList_addressItem_3QhGr.AddressList_active_1r50K {\n  transition: all 0.5s ease 0.3s;\n  background-color: #f0f7fd;\n  height: 495px;\n}\n\n.AddressList_newAddressItem_BI9z8 {\n  height: 0px;\n}\n\n.AddressList_newAddressItem_BI9z8.AddressList_active_1r50K {\n  height: 425px;\n}\n\n.AddressList_activeChildren_FBdun {\n  overflow: hidden;\n}\n\n.AddressList_createButton_6MruW {\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  transition: all 0.5s ease;\n  transform: translate3d(0,0,0);\n}\n\n.AddressList_createButton_6MruW.AddressList_active_1r50K {\n  bottom: -60px;\n}\n\n.AddressList_empty_39CDp {\n  margin: 0 24px;\n  font-size: 15px;\n}\n\n.AddressList_divider_2G7tv {\n  margin: 1px 25px 0;\n}\n", ""]);

// exports
exports.locals = {
	"primaryText": "AddressList_primaryText_vZ4uH",
	"addressItem": "AddressList_addressItem_3QhGr",
	"active": "AddressList_active_1r50K",
	"newAddressItem": "AddressList_newAddressItem_BI9z8",
	"activeChildren": "AddressList_activeChildren_FBdun",
	"createButton": "AddressList_createButton_6MruW",
	"empty": "AddressList_empty_39CDp",
	"divider": "AddressList_divider_2G7tv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/AddressList/AddressList.css
// module id = 1209
// module chunks = 2